import React, { useState } from 'react';
import { TableIds } from 'src/api/types/misc';
import Audit from 'src/components/Audit';
import ExpandSection from 'src/components/ExpandSection';
import { SelectedOrgUnit } from '../types';

interface AuditSectionProps {
  userId: number;
  selectedOrgUnit?: SelectedOrgUnit;
}

export const AuditSection: React.FC<AuditSectionProps> = ({ userId, selectedOrgUnit }) => {
  const [isOpen, setIsOpen] = useState(false);

  const title = selectedOrgUnit ? `Audit log for ${selectedOrgUnit.name}` : 'AUDIT';

  return (
    <ExpandSection title={title} defaultOpen={false} onChange={setIsOpen} sectionId="user_audit">
      {isOpen && (
        <div>
          <Audit
            noHide
            topSpacer={0}
            maxHeight={800}
            tableId={TableIds.auditUser}
            rootPath={'users'}
            initQuery={{
              user_id: userId,
              workspace_id: selectedOrgUnit?.recordType === 'W' ? selectedOrgUnit?.id : undefined,
              organisation_id: selectedOrgUnit?.recordType === 'O' ? selectedOrgUnit?.id : undefined,
            }}
            customLabel={
              selectedOrgUnit
                ? {
                    open: `Hide audit log for ${selectedOrgUnit.name}${
                      selectedOrgUnit.recordType === 'O' ? ' [Organisation]' : '[Workspace]'
                    }`,
                    close: `Show audit log for ${selectedOrgUnit.name}${
                      selectedOrgUnit.recordType === 'O' ? ' [Organisation]' : '[Workspace]'
                    }`,
                  }
                : undefined
            }
            initialShowAudit={true}
          />
        </div>
      )}
    </ExpandSection>
  );
};
